// extracted by mini-css-extract-plugin
export default {"container":"campaignActivityStatus_container__EI-0U"};